import { render, staticRenderFns } from "./LegoChat.vue?vue&type=template&id=f79460be&scoped=true"
import script from "./LegoChat.vue?vue&type=script&lang=js"
export * from "./LegoChat.vue?vue&type=script&lang=js"
import style0 from "./LegoChat.vue?vue&type=style&index=0&id=f79460be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79460be",
  null
  
)

export default component.exports